import { Container, Navbar } from "react-bootstrap";
import Logo from '../../assets/images/myfx-logo.png'
import { useNavigate } from "react-router-dom";
import MobileLogo from "../../assets/images/myfx-logo.png"
import { useSelector } from "react-redux";


const Header = () => {
    const navigate = useNavigate();
    const adminName = useSelector((state: any) => state?.items?.permissions?.[0]?.title || "No Role Assigned");

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar>
                        {/* <a
                            href="javascript:void(0);"
                            className={`text-primary-2 d-lg-none mo-menu-toggle${menuOpen ? ' mo-menu-open' : ''}`}
                            onClick={handleMenuToggle}
                        >
                            <RiMenuUnfoldLine size="24" />
                        </a> */}
                        <Navbar.Brand className="" style={{ cursor: "pointer" }} onClick={() => navigate("/dashboard")}>
                            <div className="d-flex gap-3">
                                <img src={Logo} width={45} height={45} alt='Logo' className=" align-text-top d-none d-lg-block" />
                                <span className="mt-1" style={{ color: "#daaf51", fontSize: "16px", fontFamily: "Sansation" }}>Welcome, {adminName}</span>
                            </div>
                            <img src={MobileLogo} width={45} height={45} alt='Logo' className=" align-text-top d-lg-none d-block" />
                        </Navbar.Brand>
                        {/* <div className="d-block d-lg-none ms-auto">
                            <Dropdown className="module-dd"  align="end" autoClose='outside'>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                     <img src={activeModule.icon} className="menu-icon" alt="icon" /> {activeModule.text}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <ModuleNav />
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="d-none d-lg-block">
                            <ModuleNav />
                        </div> */}
                        {/* <div className="d-none d-lg-block align-items-center ms-auto gap-3 col-lg-3" >
                            <div className="w-100">
                                <CommonSearch />
                            </div>
                        </div> */}
                        <div className="d-none d-lg-flex align-items-center ms-auto gap-3">
                            {/* <Button
                                variant="outline-danger"
                                size="sm"
                                className="d-flex align-items-center gap-2"
                                onClick={() => setShowLogout(true)}
                            >
                                <RiLogoutBoxRLine size={18} />
                            </Button> */}
                        </div>


                    </Navbar>
                </Container>
            </header>

        </>
    )
}
export default Header;